import _toConsumableArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as s } from "react";
import { useIsoMorphicEffect as f } from './use-iso-morphic-effect.js';
import { useLatestValue as m } from './use-latest-value.js';

function i(e, o) {
  var _s = s(e),
      _s2 = _slicedToArray(_s, 2),
      u = _s2[0],
      t = _s2[1],
      r = m(e);

  return f(function () {
    return t(r.current);
  }, [r, t].concat(_toConsumableArray(o))), u;
}

export { i as useComputed };